import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    newPassword: Yup.string().required("This field is required"),
    confirmPassword: Yup.string().required("This field is required")
  }),
  validate: values => {
    const errors = {};
    const pattern = new RegExp(".*[@#$%^&+=!]");
    const pattern2 = new RegExp("(?=.*[A-Za-z])");
    const pattern3 = new RegExp("(?=.*[0-9])");

    if (values.newPassword) {
      if (values.newPassword.length < 15 || values.newPassword.length > 64) {
        errors.newPassword = "Password must be between 15 and 64 characters.";
      } else if (!pattern.test(values.newPassword)) {
        errors.newPassword = `Password must have at-least one special character`;
      } else if (!pattern2.test(values.newPassword)) {
        errors.newPassword = `Password must have at-least one Letter `;
      } else if (!pattern3.test(values.newPassword)) {
        errors.newPassword = `Password must have at-least one Number `;
      }
    }

    if (
      values.confirmPassword &&
      values.newPassword !== values.confirmPassword
    ) {
      errors.confirmPassword = "Password does not matched";
    }
    return errors;
  },
  mapPropsToValues: props => ({
    newPassword: "",
    confirmPassword: ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
